<template>
  <div>
    <div class="phoneAndBox">
      <!-- <div class="phoneNumShowIcon" style="position:relative;z-index:6;">
        <a href="tel:4006688991">
          <img
            class="phone-icon"
            src="~/assets/image/homePage/index/PhoneImage/phone.png"
            alt=""
            style="width:100%;height:100%;"
          >
        </a>
      </div> -->
      <div @click="scorllTop" class="scorllTopCur" :class="isShow? 'hide':''">
        <img
          src="~/assets/image/homePage/index/PhoneImage/back-top.png"
          alt=""
          style="width:100%;height:100%;"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    //鼠标滚动事件
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      var clientHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      if (scrollTop >= clientHeight - 500) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    scorllTop: function() {
      //   scrollTo(0, 0);
      this.isShow = false;

      //带动画效果的回到顶部
      var timer = null;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        var oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          scrollTo(0, oTop - 300);
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 998px){
  .phoneAndBox{
    display: none;
  }
}
.phoneAndBox {
  position: fixed;
  right: 1vw;
  top: 50%;
  z-index: 1000;
  .phoneNumShowIcon {
    box-shadow:0px 2px 10px 12px rgba(0,0,0,0.05);
    width: vt(60);
    height: vt(60);
    a {
      width: 100%;
      height: 100%;
      display: inline-block;
    }
    img {
      width: 100%;
    }
  }
  .scorllTopCur {
    height: vt(60);
    width: vt(60);
    display: none;
    margin-top:vt(10);
    transition: all 0.5s;
    box-shadow:0px 2px 10px 12px rgba(0,0,0,0.05);
  }
  .scorllTopCur.hide {
    display: block;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/BackTop.vue